import { createFileRoute, redirect, stripSearchParams } from '@tanstack/react-router';

import AdminHeader from '@/components/Admin/AdminHeader';
import Charts from '@/components/Admin/Charts';
import Metrics from '@/components/Admin/Metrics';
import RecentTrendsTable from '@/components/Admin/RecentTrendsTable';

import { getUser } from '@/lib/authServer';

import { defaultSearch, searchSchema } from '@/components/Admin/RecentTrendsTableToolbar';

export const Route = createFileRoute('/admin')({
  validateSearch: searchSchema,
  search: {
    middlewares: [stripSearchParams(defaultSearch)],
  },
  component: AdminPage,
  beforeLoad: async () => {
    const user = await getUser();

    return { user };
  },
  loader: async ({ context }) => {
    if (!context.user.id) throw redirect({ to: '/signin' });

    return { user: context.user };
  },
  preload: false,
  preloadStaleTime: 5 * 60 * 1000, // 5 minutes
  head: () => ({
    meta: [
      {
        name: 'Bluesky Trends Admin',
        content: 'Admin Dashboard',
      },
      {
        title: 'Bluesky Trends Admin',
      },
    ],
  }),
});

function AdminPage() {
  const { user } = Route.useLoaderData();

  return (
    <div>
      <nav className="w-full border-gray-200 border-b-2 bg-gray-50 px-4 py-2">
        <AdminHeader user={user} />
      </nav>
      <main className="flex max-w-7xl flex-col gap-4 p-4">
        <Metrics />
        <Charts />
        <RecentTrendsTable />
      </main>
    </div>
  );
}
